import React from "react";
import {openMotion} from "../../constants/collapse";
import 'rc-collapse/assets/index.css';
import Collapse, {Panel} from 'rc-collapse';
import {safeHTML} from "../../utils/safeHTML";
import styles from "./HoroscopeFaq.module.scss";


const HoroscopeFaq = React.forwardRef(
  function HoroscopeFaq(props, ref) {
    const {faq} = props;

    const arrowPath = "M2.36145 0.5C0.510043 0.5 -0.347499 2.79883 1.05159 4.01138L10.6901 12.3648C11.4419 13.0163 12.5581 13.0163 13.3099 12.3648L22.9484 4.01138C24.3475 2.79884 23.49 0.5 21.6385 0.5L12 0.5L2.36145 0.5Z";

    function expandIcon({ isActive }) {
      return (
        <i style={{}}>
          <svg
            viewBox="0 0 24 13"
            width="1em"
            height="1em"
            fill="currentColor"
            style={{
              // verticalAlign: '-.125em',
              transition: 'transform .2s',
              transform: `rotate(${isActive ? 180 : 0}deg)`,
            }}
          >
            <path d={arrowPath}  fill={"#212121"}/>
          </svg>
        </i>
      );
    }

    return (
      <div className={styles.horoscopeFaq} ref={ref}>
        <div className={styles.horoscopeFaq__content}>
          <Collapse
            accordion={true}
            openMotion={openMotion} //анимированное раскрытие элемента из constants/collapse
            style={{
              border:"none",
              borderRadius:0,
              background:"none",
              color: "#212121",
            }}
            className={styles.horoscopeFaq__list}
            expandIcon={expandIcon}
          >
            {faq?.map(({question,answer},index)=>
              <Panel header={safeHTML(question)} key={`panel-${index}`}
                     className={styles.horoscopeFaq__item}
                     headerClass={styles.horoscopeFaq__itemHeader}
                     style={{
                       borderTop:'none',
                       marginBottom: index === faq.length - 1 && "0",
                     }}
              >
                {safeHTML(answer)}
              </Panel>
            )}

          </Collapse>
        </div>

      </div>
    );
  });
export default HoroscopeFaq;
HoroscopeFaq.propTypes = {};

